import { GET_LANGUAGE, GET_LANGUAGE_ON_LOAD } from './types';
import axios from 'axios';
import content_hebrew from '../content/content_hebrew';
import content_arabic from '../content/content_arabic';
import content_english from '../content/content_english';

export const getLanguage = (language) => async (dispatch) => {
    let data;
    let selected_language;
    let lang;
    let content;
    if (language === 'heb') {
        lang = 'hebrew';
        selected_language = 'עברית';
        content = content_hebrew;
    }
    if (language === 'eng') {
        lang = 'english';
        selected_language = 'English';
        content = content_english;
    }
    if (language === 'arabic') {
        lang = 'arabic';
        selected_language = 'عربى';
        content = content_arabic;
    }
    dispatch({
        type: GET_LANGUAGE,
        payload: { data: content, lang, selected_language },
    });
};

export const getLanguageOnLoad = (language) => async (dispatch) => {
    let data;
    let lang;
    let content;

    if (language === 'heb') {
        lang = 'hebrew';
        content = content_hebrew;
    }
    if (language === 'eng') {
        lang = 'english';
        content = content_english;
    }
    if (language === 'arabic') {
        lang = 'arabic';
        content = content_arabic;
    }

    dispatch({
        type: GET_LANGUAGE,
        payload: { data: content, lang },
    });
};
